module.exports = __webpack_public_path__ + "img/ABX-grey.3ca0207f.png";